import { PageLayout } from "@/shared/components";
import type { FilterDefinition } from "@/shared/components/ResourceView";
import {
  coreSessionFilters,
  sessionResourceIdFilter,
  SessionsList,
} from "@/shared/components/sessions";

/**
 * Filter-menu surface for the unscoped `/sessions` page. Both
 * cross-aggregate id rows are user-narrowable here because no server-side
 * scope is applied.
 */
const sessionsPageFilterDefinitions: FilterDefinition[] = [
  ...coreSessionFilters,
  {
    type: "string",
    field: "dataset.dataset_id",
    name: "Dataset ID",
    allowedComparators: sessionResourceIdFilter.comparators,
    icon: sessionResourceIdFilter.icon,
  },
  {
    type: "string",
    field: "device.device_id",
    name: "Device ID",
    allowedComparators: sessionResourceIdFilter.comparators,
    icon: sessionResourceIdFilter.icon,
  },
];

/**
 * Top-level `/sessions` page. Wraps the shared `SessionsList` in
 * `PageLayout` and surfaces the unscoped picker.
 */
export function SessionsPage() {
  return (
    <PageLayout title="Roboto - Sessions" headerContentLeft="Sessions">
      <SessionsList
        filterDefinitions={sessionsPageFilterDefinitions}
        noRowsContent="No sessions created yet"
      />
    </PageLayout>
  );
}
